var map = {
	"./add-more-role.svg": 856,
	"./assign.svg": 725,
	"./back_arrow.svg": 857,
	"./cancel.svg": 858,
	"./card_download.svg": 859,
	"./card_edit.svg": 860,
	"./card_refresh.svg": 861,
	"./cards.svg": 470,
	"./close-popup.svg": 862,
	"./collapse.svg": 471,
	"./completed-register.svg": 726,
	"./connectionAnalysis.svg": 863,
	"./contact-hotline.svg": 472,
	"./dd_contact hotline.svg": 864,
	"./dd_diagnostic_info.svg": 865,
	"./dd_file_management.svg": 866,
	"./dd_inventory_information.svg": 867,
	"./dd_my_contract.svg": 868,
	"./dd_peripheral_devices.svg": 869,
	"./dd_process_information.svg": 870,
	"./dd_system_configuration.svg": 871,
	"./dd_water_parameters.svg": 872,
	"./device-button.svg": 701,
	"./deviceCertificate.svg": 873,
	"./deviceSoftware.svg": 473,
	"./deviceStatus.svg": 874,
	"./devices.svg": 875,
	"./devicesUsage.svg": 876,
	"./download-csr.svg": 727,
	"./download.svg": 221,
	"./download_kpi.svg": 711,
	"./edit-cards.svg": 728,
	"./exclamatory.svg": 877,
	"./file-doc.svg": 878,
	"./file-docx.svg": 879,
	"./file-pdf.svg": 880,
	"./file-ppt.svg": 881,
	"./file-pptx.svg": 882,
	"./file-text.svg": 883,
	"./file-xls.svg": 884,
	"./file-xlsx.svg": 885,
	"./file.svg": 886,
	"./fileManagement.svg": 474,
	"./file_csv.svg": 887,
	"./file_jpg.svg": 888,
	"./file_pdf.svg": 889,
	"./filter-sm.svg": 890,
	"./filter_kpi.svg": 704,
	"./home.svg": 891,
	"./in-progress.svg": 729,
	"./iotConnction.svg": 730,
	"./loading.svg": 731,
	"./logo_merck_loader.svg": 892,
	"./marketAnalysis.svg": 893,
	"./minus.svg": 894,
	"./notification status.svg": 895,
	"./notification-preferences.svg": 896,
	"./notificationAnalysis.svg": 897,
	"./notvalidated.svg": 732,
	"./personal-details.svg": 898,
	"./quality rep.svg": 899,
	"./question-mark.svg": 900,
	"./r_dKnowledge.svg": 901,
	"./refresh-cards.svg": 733,
	"./refresh-circle.svg": 902,
	"./register-iot-disabled.svg": 734,
	"./register-iot.svg": 735,
	"./remote access.svg": 903,
	"./remote control.svg": 904,
	"./remoteConnection.svg": 736,
	"./request config.svg": 905,
	"./service-contract-management.svg": 475,
	"./service_contract_add.svg": 906,
	"./service_contract_edit.svg": 907,
	"./service_contract_refresh.svg": 908,
	"./service_contract_right_mark.svg": 909,
	"./settings.svg": 910,
	"./softwareUpgrades.svg": 737,
	"./sw-accepted-icon.svg": 712,
	"./sw-installation-failed.svg": 738,
	"./sw-installing.svg": 739,
	"./sw-not-authorized.svg": 740,
	"./sw-pending.svg": 721,
	"./sw-ready-to-install.svg": 741,
	"./sw-recall.svg": 722,
	"./sw-rejected.svg": 705,
	"./sw-release-acceptance.svg": 742,
	"./sw-release-fail.svg": 743,
	"./sw-release-installed.svg": 911,
	"./sw-update-available.svg": 744,
	"./sw-update-diabled.svg": 745,
	"./upload-csr.svg": 746,
	"./upto-date.svg": 912,
	"./user-preferences.svg": 913,
	"./userManagement.svg": 476,
	"./validated.svg": 747,
	"./waiting.svg": 914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 547;